import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RmColumnDropDownDto } from './rm-column-drop-down.dto';




export class RmColumnsDropDownResponseModel extends GlobalResponseObject {
    data?: RmColumnDropDownDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: RmColumnDropDownDto[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}

